import React from 'react'
import ReactGA from 'react-ga'
import { Link, useNavigate } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { menuItems, menuItems2 } from '../../../consts/menuItems'
import { scrollToAnchor } from '../../../helpers/scrollToAnchor'
import styles from '../../Header/header.module.scss'
import { MapPoint } from '../../icons/MapPoint'
import { PhoneIcon } from '../../icons/PhoneIcon'
import { BurgerMenuTypes } from './BurgerMenu.types'

export const BurgerMenu = ({
  handleClickBurger,
  componentToShow,
  pageComponent,
}: BurgerMenuTypes) => {
  const navigate = useNavigate()

  const handleLinkClick = (
    name: string,
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault()
    const link = e.currentTarget.href.split('/')

    if (
      e.currentTarget.href.split('#')[0] === window.location.href.split('#')[0]
    ) {
      scrollToAnchor(e)
    } else {
      navigate(`/${link.pop()}`)
    }

    ReactGA.ga('send', 'event', 'main', 'filters click', name)
    ym('reachGoal', 'filters click', {
      'filters click': {
        main: {
          'filters name': name,
        },
      },
    })

    handleClickBurger()
  }

  return (
    <div className={styles.menu__wrapper}>
      <div className={styles.menu}>
        {(componentToShow === pageComponent ? menuItems2 : menuItems).map(
          el => (
            <Link
              key={el.linkId}
              className={styles.menu__item}
              to={el.linkId}
              onClick={e => handleLinkClick(el.name, e)}
              dangerouslySetInnerHTML={{ __html: el.name }}
            ></Link>
          )
        )}
      </div>
      {componentToShow === pageComponent && (
        <div className={[styles.icon, styles['icon--map']].join(' ')}>
          <Link to='/#newBuildings' onClick={e => handleLinkClick('карта', e)}>
            <MapPoint />
          </Link>
        </div>
      )}

      <div className={styles.phone}>
        <a
          href='tel:+74958592182'
          onClick={() => {
            ReactGA.ga(
              'send',
              'event',
              'main',
              'filters click',
              'Связаться с нами'
            )
          }}
        >
          <PhoneIcon />
        </a>
      </div>
    </div>
  )
}
